import { useState } from "react";
import "./App.css"; // import custom CSS
import { MapPin, Instagram } from "lucide-react";
import portabello from "./img/portabello.jpg"; // relative to this file
import bruschetta from "./img/bruschetta.jpg"; // relative to this file
import cheese from "./img/cheese.jpg"; // relative to this file
import soppressata from "./img/soppressata.jpg"; // relative to this file

function InstagramBar() {
  return (
    <div className="instagram-bar">
      <a
        href="https://instagram.com/doughworkpizza"
        target="_blank"
        rel="noopener noreferrer"
        className="instagram-link"
      >
        <Instagram size={44} />
      </a>
    </div>
  );
}

function Navbar({ setPage }: { setPage: (page: string) => void }) {
  return (
    <>
      <nav className="navbar">
        <div className="navbar-left">
          <div className="navbar-logo-container">
            <img
              src="/pizza-logo.png"
              alt="Doughwork Pizza Logo"
              className="navbar-logo"
            />
          </div>
        </div>
        <div className="navbar-right">
          <button onClick={() => setPage("home")}>Home</button>
          <button onClick={() => setPage("menu")}>Menu</button>
          <button onClick={() => setPage("about")}>About</button>
        </div>
      </nav>
    </>
  );
}

function HomePage() {
  return (
    <div className="home">
      <div className="logo-container">
        <img
          src="/doughwork-logo.png"
          alt="Doughwork Pizza Logo"
          className="logo"
        />
      </div>

      <InstagramBar />

      <section className="locations">
        <h2>Find us at the Westchester Farmers’ Market on Sundays</h2>
        {
          <p className="location-item">
          <MapPin size={20} className="map-icon" />
          <a
            href="https://www.google.com/maps/place/6200+W+87th+St,+Los+Angeles,+CA+90045"
            target="_blank"
            rel="noopener noreferrer"
            className="location-link"
          >
            Sundays Westchester Farmers’ Market
          </a>
        </p>
        /*
        <p className="location-item">
          <MapPin size={20} className="map-icon" />
          <a
            href="https://www.google.com/maps/place/1035+Valley+Dr,+Hermosa+Beach,+CA+90254"
            target="_blank"
            rel="noopener noreferrer"
            className="location-link"
          >
            Hermosa Beach Farmers Market
          </a>
        </p> */}
      </section>
      <section className="contact">
        <h2>Contact</h2>
        <a href="mailto:nomnom@doughworkpizza.com">nomnom@doughworkpizza.com</a>
      </section>
    </div>
  );
}

function AboutPage() {
  return (
    <div className="about-page">
      <section className="about">
        <h2>About</h2>
        <p>
          Doughwork Pizza is made from scratch with long-fermented sourdough for a soft, pillowy crust. Our Detroit-style pies are square, baked in classic Lloyd pans, and topped with fresh, thoughtfully chosen ingredients.
          </p>
          <br />
          <p>
            They’re made to be shared — or eaten all by yourself. No judgment. Just good pizza, however you want to enjoy it.
          </p>
      </section>

      <InstagramBar />
    </div>
  );
}

function MenuPage() {
  return (
    <section className="menu">
      <h2>Menu</h2>
      <div className="pizza-grid">
        <div className="pizza-card">
          <img src={soppressata} alt="Soppresetta Pizza" />
          <h3>Soppresetta</h3>
          <p className="ingredients">
            Soppressata (Italian salami, pepperoni-style), Burrata, Cheese
            Blend, Tomato Sauce, Hot Honey
          </p>
        </div>

        <div className="pizza-card">
          <img src={portabello} alt="Portobello Mushroom Pizza" />
          <h3>Portobello Mushroom</h3>
          <p className="ingredients">
            Portobello Mushroom, Crème Fraîche, Cheese Blend, Onion, Parsley
          </p>
        </div>

        <div className="pizza-card">
          <img src={bruschetta} alt="Bruschetta Pizza" />
          <h3>Bruschetta</h3>
          <p className="ingredients">
            Cherry Tomatoes, Shallots, Garlic, Olive Oil, Balsamic, Cheese Blend
          </p>
        </div>

        <div className="pizza-card">
          <img src={cheese} alt="Cheese Pizza" />
          <h3>Cheese</h3>
          <p className="ingredients">Tomato Sauce, Cheese Blend</p>
        </div>
      </div>

      <InstagramBar />
    </section>
  );
}

export default function App() {
  const [page, setPage] = useState("home");

  return (
    <div className="app">
      <Navbar setPage={setPage} />

      <div className="page-content">
        {page === "home" && <HomePage />}
        {page === "about" && <AboutPage />}
        {page === "menu" && <MenuPage />}
      </div>

      <footer className="footer">
        © {new Date().getFullYear()} Doughwork Pizza LLC. All rights reserved.
      </footer>
    </div>
  );
}
